<template>
    <div class="wrapper" id="settingsPushWrapper">
        <section v-if="doneLoading">
            <h2>Push notifications</h2>

            <section id="general-section">
              <h4>General</h4>
              <div class="row no-margin">
                <custom-input type="textarea" v-model="genericPushMessage" label="Generic push message" placeholder="Push message" maxlength="450"/>
                <help-popover>
                  <template slot="content">
                    <p>Once this is set, the content of a push notification will not contain the actual message that has been received but instead
                      it will contain this 'generic' message</p>
                  </template>
                </help-popover>
              </div>
            </section>

            <button class="primary" @click="saveSettings">Save</button>
        </section>

        <p v-if="showLoading && !doneLoading">
            Loading push settings...
        </p>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import CustomInput from '../additional/customInput';
import HelpPopover from '../additional/helpPopover';

export default {
    components: {
        HelpPopover,
        CustomInput
    },
    name: 'settingsPush',
    mixins: [
        Default
    ],
    inject: {
        $validator: '$validator'
    },
    data() {
        return {
            showLoading: false,
            doneLoading: false,
            genericPushMessage: '',
            originalGeneralSettings: {
                genericPushMessage: null
            }
        };
    },
    created: async function() {
        // Only show loading when it takes longer than X ms
        window.setTimeout(() => {
            this.showLoading = true;
        }, 500);

        // Get general settings
        await this.getGENERAL();

        this.doneLoading = true;
    },
    computed: {
        isGeneralDirty: {
            get() {
                return this.originalGeneralSettings.genericPushMessage !== this.genericPushMessage;
            }
        }
    },
    methods: {
        getGENERAL: function() {
            return this.$http.get('v1.1/config').then(response => {
                // Success callback
                this.genericPushMessage = response.data.data.genericPushMessage;
                this.originalGeneralSettings.genericPushMessage = this.genericPushMessage;
            }, () => {
                // Error callback
                this.$parleyAdmin.queryErrors.addError('Something went wrong while retrieving the General settings');
            });
        },
        saveSettings: async function() {
            if (!this.isWebDirty && !this.isAndroidDirty && !this.isGeneralDirty)
                this.$parleyAdmin.queryErrors.addError('There is nothing to save', this.$parleyAdmin.queryErrors.TYPE_INFO);

            let failedString = [];
            let successString = [];

            if (this.isGeneralDirty) {
                if(!await this.saveGENERAL(this.genericPushMessage)) {
                    failedString.push('general');
                } else {
                    this.originalGeneralSettings.genericPushMessage = this.genericPushMessage; // Don't forget to reset the originals so the isDirty state will reset to false
                    successString.push('general');
                }
            }

            if (failedString.length > 0) {
                failedString = failedString.join(', ');
                this.$parleyAdmin.queryErrors.addError(`Something went wrong while updating push settings for <b>${failedString}</b>, please try again later`);
            }

            if (successString.length > 0) {
                successString = successString.join(', ');
                this.$parleyAdmin.queryErrors.addError(`Successfully saved changes for <b>${successString}</b>`, this.$parleyAdmin.queryErrors.TYPE_SUCCESS);
            }
        },
        saveGENERAL: function(genericPushMessage) {
            return new Promise((resolve) => {
                return this.$http.put('v1.1/config', {
                    genericPushMessage: genericPushMessage
                }).then(() => {
                    // Success callback
                    resolve(true);
                }, () => {
                    // Error callback
                    resolve(false);
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    #settingsPushWrapper { /* Using ID because class (.wrapper) also changed the underlying .wrapper's */
        width: 32em;
        padding: .25em;

        #general-section {
          .custom-input {
            width: 90%;
          }
        }

        h4 {
            padding: 0;
        }
    }
</style>
